import { render, staticRenderFns } from "./reverse-shipment.vue?vue&type=template&id=3971d374&"
import script from "./js/reverse-shipment.js?vue&type=script&lang=js&"
export * from "./js/reverse-shipment.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports